import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const faqItems = [
  {
    q: '韩漫网的漫画都是免费的吗？',
    a: '是的！韩漫网所有漫画资源完全免费，无需注册付费即可畅享全部内容。我们致力于为漫画爱好者提供最优质的免费阅读体验。',
  },
  {
    q: '需要下载APP才能看漫画吗？',
    a: '不需要。韩漫网是纯网页端在线阅读平台，在任何浏览器中都可直接访问阅读，无需下载任何应用。我们的响应式设计完美适配手机、平板和电脑。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '韩漫网每日零点更新最新漫画章节，确保读者能在第一时间追更。热门连载作品保持与韩国同步更新的节奏，绝不让您错过任何精彩内容。',
  },
  {
    q: '为什么选择下拉式阅读模式？',
    a: '下拉式阅读是韩漫的特色阅读方式，相比传统翻页，它能带来更流畅的阅读体验。画面衔接自然，节奏感更强，特别适合移动端阅读，让您沉浸在漫画世界中。',
  },
  {
    q: '画质有保障吗？',
    a: '韩漫网所有漫画均为高清画质，确保每一格画面的细节清晰可见。我们采用优化的图片加载技术，在保证画质的同时最大化加载速度，打造影院级观看体验。',
  },
  {
    q: '如何联系客服反馈问题？',
    a: '您可以通过页面底部的联系方式或发送邮件至 hello@mostlive.cn 与我们联系。我们的客服团队会在24小时内回复您的反馈与建议。',
  },
];

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main>
        <section className="bg-background-100 pt-24 pb-10">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-700 font-medium">关于我们</span>
            </nav>
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">关于韩漫网</h1>
          </div>
        </section>

        <section id="intro" className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-4xl">
            <span className="text-primary-600 text-xs font-semibold tracking-widest uppercase mb-3 block">品牌介绍</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
              韩漫爱好者的精神家园
            </h2>
            <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              <p>
                韩漫网成立于2024年，是国内领先的<strong>免费韩漫在线阅读平台</strong>。我们始终致力于为广大漫画爱好者提供<strong>高清下拉式韩漫全集</strong>资源，覆盖恋爱、奇幻、动作、悬疑、喜剧、剧情等全类型<strong>韩国漫画</strong>。
              </p>
              <p>
                我们深知好的阅读体验对漫画迷有多重要。因此，韩漫网坚持"高清画质 + 流畅阅读"的核心理念，采用先进的下拉式阅读技术，让每一话漫画都如电影般流畅呈现。无论是手机、平板还是电脑，都能享受<strong>影院级韩漫阅读体验</strong>。
              </p>
              <p>
                截至目前，韩漫网已收录超过500部精选<strong>免费韩漫</strong>，累计服务超过百万漫画读者。我们与韩国多家知名漫画平台建立了合作关系，确保内容正版、更新及时、品质上乘。
              </p>
            </div>
          </div>
        </section>

        <section id="reputation" className="bg-background-100 py-14 md:py-20">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <span className="text-accent-600 text-xs font-semibold tracking-widest uppercase mb-3 block">平台信誉</span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                为什么选择韩漫网
              </h2>
              <p className="text-foreground-500 text-sm max-w-xl mx-auto">用心打磨每一个细节，只为给你最好的阅读体验</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
                <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-4">
                  <i className="ri-image-line text-xl text-primary-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">高清画质</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">全站漫画采用高清画质，细节丰富、色彩饱满，确保每一格画面的视觉享受。</p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
                <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                  <i className="ri-speed-line text-xl text-accent-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">流畅阅读</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">下拉式阅读技术，画面无缝衔接。优化的加载机制使阅读过程如丝般顺滑。</p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
                <div className="w-11 h-11 rounded-lg bg-secondary-100 flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">完全免费</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">无需注册、无需付费，所有漫画资源永久免费。我们相信好内容应该人人可享。</p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
                <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                  <i className="ri-timer-flash-line text-xl text-accent-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">每日更新</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">热门连载每日零点更新，与韩国同步。不错过任何一部心仪作品的更新进度。</p>
              </div>
            </div>
          </div>
        </section>

        <section id="faq" className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <span className="text-secondary-600 text-xs font-semibold tracking-widest uppercase mb-3 block">常见问题</span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">FAQ</h2>
            </div>
            <div className="space-y-3">
              {faqItems.map((item, index) => (
                <details key={index} className="group bg-background-100 rounded-xl border border-background-200/60">
                  <summary className="px-6 py-4 cursor-pointer list-none flex items-center justify-between">
                    <span className="text-foreground-800 font-medium text-sm">{item.q}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-6 pb-4">
                    <p className="text-foreground-500 text-sm leading-relaxed">{item.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section id="contact" className="bg-background-100 py-14 md:py-20">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <span className="text-primary-600 text-xs font-semibold tracking-widest uppercase mb-3 block">联系我们</span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                商务合作 &amp; 意见反馈
              </h2>
              <p className="text-foreground-500 text-sm mb-8">
                如果您有任何合作意向、版权问题或意见建议，欢迎通过以下方式联系我们
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
                  <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-3 mx-auto">
                    <i className="ri-mail-line text-xl text-primary-600"></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">电子邮箱</h3>
                  <p className="text-foreground-500 text-xs">hello@mostlive.cn</p>
                </div>
                <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
                  <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-3 mx-auto">
                    <i className="ri-wechat-line text-xl text-accent-600"></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">微信公众号</h3>
                  <p className="text-foreground-500 text-xs">搜索"韩漫网"关注</p>
                </div>
                <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
                  <div className="w-11 h-11 rounded-lg bg-secondary-100 flex items-center justify-center mb-3 mx-auto">
                    <i className="ri-time-line text-xl text-secondary-600"></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">工作时间</h3>
                  <p className="text-foreground-500 text-xs">周一至周日 9:00 - 22:00</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "韩漫网",
          "url": "http://mostlive.cn/",
          "description": "韩漫网是您的免费韩漫在线阅读平台，提供高清下拉式全集漫画大全，画质清晰阅读流畅。",
          "email": "hello@mostlive.cn",
          "sameAs": [
            "http://mostlive.cn/",
            "http://mostlive.cn/user/hanmanwang"
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "email": "hello@mostlive.cn",
            "contactType": "customer service",
            "availableLanguage": ["Chinese"]
          }
        }) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqItems.map((item) => ({
            "@type": "Question",
            "name": item.q,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": item.a
            }
          }))
        }) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://mostlive.cn/" },
            { "@type": "ListItem", "position": 2, "name": "关于我们", "item": "http://mostlive.cn/about" }
          ]
        }) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "关于韩漫网 - 免费韩漫在线阅读平台",
          "description": "了解韩漫网的品牌故事、平台信誉和联系方式。韩漫网致力于提供高清下拉式韩漫全集免费阅读服务。",
          "url": "http://mostlive.cn/about"
        }) }} />
      </main>
      <Footer />
    </>
  );
}